import { render, staticRenderFns } from "./CommodityAutocomplete.vue?vue&type=template&id=76d1ad4c"
import script from "./CommodityAutocomplete.vue?vue&type=script&lang=js"
export * from "./CommodityAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports